import { render, staticRenderFns } from "./json-editor-input.vue?vue&type=template&id=95f89472&scoped=true"
import script from "./json-editor-input.vue?vue&type=script&lang=js"
export * from "./json-editor-input.vue?vue&type=script&lang=js"
import style0 from "./json-editor-input.vue?vue&type=style&index=0&id=95f89472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f89472",
  null
  
)

export default component.exports